import { isUndefined } from 'fmrs';
import { useEffect } from 'react';
import useShallowMemo from 'use-shallow-memo';
import useDatadogRum from './use-datadog-rum.js';
const isEmptyRecord = (value) => Object.values(value).every(isUndefined);
export default function useUser(user) {
    const rum = useDatadogRum();
    const userMemo = useShallowMemo(user ?? {});
    useEffect(() => {
        if (isEmptyRecord(userMemo)) {
            return;
        }
        rum.setUser(userMemo);
        return () => {
            rum.clearUser();
        };
    }, [rum, userMemo]);
}
//# sourceMappingURL=use-user.js.map